/**
 * Pure calculation helpers for quote line items and totals.
 * Same logic as purchaseCalculations.js - tax-inclusive/exclusive/none model.
 */

export function calculateLineTotal(qty, unitPrice, taxRate, taxInclusion, discount = 0) {
  const discountMultiplier = 1 - (parseFloat(discount) || 0) / 100;
  // The Amount column reflects the line amount in the same tax basis as the entered
  // unit price (Xero-style): ex-tax when "Tax exclusive", inc-tax when "Tax inclusive".
  // Tax is shown separately in the Tax amount column and added to the total.
  return qty * unitPrice * discountMultiplier;
}

export function calculateLineTax(lineItem, taxes, taxInclusion) {
  if (taxInclusion === 'no_tax' || !lineItem.tax_rate_id) return 0;

  const selectedTax = taxes.find((t) => t.tax_id === lineItem.tax_rate_id);
  const taxRate = selectedTax ? parseFloat(selectedTax.tax_rate) / 100 : 0;

  const qty = lineItem.quantity || 0;
  const price = lineItem.unit_price || 0;
  const discountMultiplier = 1 - (parseFloat(lineItem.line_discount_rate) || 0) / 100;

  if (taxInclusion === 'tax_inclusive') {
    const totalPrice = lineItem.total_price || 0;
    const subtotal = totalPrice / (1 + taxRate);
    return totalPrice - subtotal;
  }
  if (taxInclusion === 'tax_exclusive') {
    return qty * price * discountMultiplier * taxRate;
  }
  return 0;
}

export function calculateQuoteTotals(lineItems, taxes, taxInclusion) {
  let subtotal = 0;
  let taxTotal = 0;

  lineItems.forEach((item) => {
    const qty = item.quantity || 0;
    const price = item.unit_price || 0;
    const discountMultiplier = 1 - (parseFloat(item.line_discount_rate) || 0) / 100;
    const taxRateId = item.tax_rate_id || 'GST';
    const selectedTax = taxes.find((t) => t.tax_id === taxRateId);
    const taxRate = selectedTax ? parseFloat(selectedTax.tax_rate) / 100 : 0;

    let itemSubtotal;
    let itemTax;

    if (taxInclusion === 'tax_inclusive') {
      const itemTotal = item.total_price || 0;
      itemSubtotal = itemTotal / (1 + taxRate);
      itemTax = itemTotal - itemSubtotal;
    } else if (taxInclusion === 'tax_exclusive') {
      itemSubtotal = qty * price * discountMultiplier;
      itemTax = itemSubtotal * taxRate;
    } else {
      itemSubtotal = qty * price * discountMultiplier;
      itemTax = 0;
    }

    subtotal += itemSubtotal;
    taxTotal += itemTax;
  });

  return { subtotal, taxTotal, grandTotal: subtotal + taxTotal };
}

export function getTaxRate(taxRateId, taxes) {
  const selected = taxes.find((t) => t.tax_id === taxRateId);
  return selected ? parseFloat(selected.tax_rate) / 100 : 0.1;
}
